<template>
  <div>
    <district18
      v-for="(dist18, index) in this.region.dist18"
      :key="index"
      :region="region.region_code"
      :district18="dist18"
      :selectedIcs="selectedIcs"
      @changeDistrict="$emit('changeDistrict', $event)"
    />
  </div>
</template>

<script>
import District18 from '@/components/Stock/Filters/District18';

export default {
  props: ['region', 'selectedIcs'],
  components: {
    District18,
  },
};
</script>

<style lang="css" scoped>
</style>
